import { useMemo } from "react";
import { SortDescriptor } from "react-aria-components";

import { LaunchPadTrackUserProgress } from "./types";
import { LAUNCHPAD_TRACK_COLUMN_ID, SORT_CONFIG } from "./constants";

const compareValues = (
  a: LaunchPadTrackUserProgress,
  b: LaunchPadTrackUserProgress,
  key: keyof LaunchPadTrackUserProgress
) => {
  const valueA = a[key];
  const valueB = b[key];

  if (typeof valueA === "string" && typeof valueB === "string") {
    return valueA.localeCompare(valueB);
  }

  return (Number(valueA) || 0) - (Number(valueB) || 0);
};

const useLaunchPadTrackSortedUsers = (
  users: LaunchPadTrackUserProgress[],
  sortDescriptor: SortDescriptor
) => {
  return useMemo(() => {
    if (!sortDescriptor.column) {
      return users;
    }

    const sortColumn = sortDescriptor.column as LAUNCHPAD_TRACK_COLUMN_ID;
    const key = SORT_CONFIG[sortColumn] as keyof LaunchPadTrackUserProgress | undefined;

    if (!key) {
      return users;
    }

    const isAscending = sortDescriptor.direction === "ascending";

    return [...users].sort((a, b) => {
      const result = compareValues(a, b, key);
      return isAscending ? result : -result;
    });
  }, [users, sortDescriptor]);
};

export default useLaunchPadTrackSortedUsers;
